export default __webpack_public_path__ + "static/media/2.71b5f8e4.png";